import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { getQueryStringParamsFromStringUrl, logger } from '$utils'
import useWorkforceStore from '../../store'
import { AccessType, Country, PayrollSystem } from '$constants'

export default async function loader({ request: { url } }) {
  const queryParams = getQueryStringParamsFromStringUrl(url)

  logger.debug(
    '[loader] About to await AppState being ready in Request Employee Information loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Request Employee Information loader'
  )

  const { staffMemberId, country, payrollSystem, t: token } = queryParams
  if (token) {
    //ls.authorizationData is the key where angular also sets the token
    //Here we are reusing the same key in the local storage to store the
    //token when the standalone page is accessed
    window.localStorage.setItem(
      'ls.authorizationData',
      JSON.stringify({ accessToken: token, accessType: AccessType.Standalone })
    )
  }

  const getStaffMember =
    staffMemberId && country && payrollSystem && token
      ? useWorkforceStore
          .getState()
          .getStaffMemberPersonalDetails(
            staffMemberId,
            country as Country,
            payrollSystem as unknown as PayrollSystem
          )
      : null

  //This is only available for XeroAu, which is already taken into account
  //when checking the connectivity
  const getSuperFunds =
    token &&
    (payrollSystem as unknown as PayrollSystem) === PayrollSystem.XeroAu
      ? useWorkforceStore.getState().getSuperFunds()
      : []

  return defer({
    data: Promise.all([getStaffMember, getSuperFunds])
      .then(() => true)
      .catch((error) => {
        logger.error('Request Employee Information Promise.all error', error)
        return false
      }),
  })
}
